export default "__VITE_ASSET__Dxv1RaWj__"